import aesGcm from './aes-gcm';
import diffieHellman from './diffie-hellman';
import ecdsa from './ecdsa';
import ecdh from './ecdh';
import sha256 from './sha-256';
import hmac from './hmac';
import hkdf from './hkdf';
import scrypt from './scrypt';
var SEED_BYTE_SIZE = 32; // 256 / 8

var generateSeed = function generateSeed() {
  return window.crypto.getRandomValues(new Uint8Array(SEED_BYTE_SIZE));
};

export default {
  generateSeed: generateSeed,
  aesGcm: aesGcm,
  diffieHellman: diffieHellman,
  ecdsa: ecdsa,
  ecdh: ecdh,
  sha256: sha256,
  hmac: hmac,
  hkdf: hkdf,
  scrypt: scrypt
};